<template>
  <div>
    <!-- 路由插槽：路由跳转的位置 -->
    <!-- 被keep-alive包含的组件会被缓存 -->
    <!-- <keep-alive :exclude="['faultDiaresPage','xlDiaresPage','xlDetialsPage','changeUserPage','changeFacePage','myPage','noticyPage','FHQXPage']">       -->
      <keep-alive>
        <!-- <transition name="fade" mode="out-in">
          <router-view></router-view>
      </transition> -->
      <transition  mode="out-in">
          <router-view></router-view>
      </transition>

    </keep-alive>

    <van-tabbar v-model="active" class="active_tab">
      <van-tabbar-item
        :badge="index == 2&&unreadNum>0 ? unreadNum : ''"
        v-for="(item, index) in tabbars"
        :key="index"
        @click="tab(index, item.path)"
      >
        <span :class="currIndex == index ? active : ''">{{ item.title }}</span>
        <template slot="icon" slot-scope="props">
          <img :src="props.active ? item.active : item.normal" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, Notify } from 'vant'

Vue.use(Tabbar, TabbarItem, Notify)

export default {
  name: 'home',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Notify.Component.name]: Notify.Component
  },
  watch: {
    '$route': function (to, from) {
      // console.log(to)
      // this.currentRouter = to.path
      if (from.path === '/xlPage') {
        this.currIndex = 1
      } else if (from.path === '/faultPage') {
        this.currentClass = 2
      } else if (from.path === '/myPage') {
        this.currentClass = 3
      }
      if (to.path === '/tjPage') {
        this.active = 0
      } else if (to.path === '/xlPage') {
        // alert(1)
        this.active = 1
      } else if (to.path === '/faultPage') {
        this.active = 2
      } else if (to.path === '/myPage') {
        this.active = 3
      }
    }
  },
  beforeMount () {
    if (this.$route.path === '/tjPage') {
      // this.currIndex = 0
      this.active = 0
    } else if (this.$route.path === '/xlPage') {
      // this.currIndex = 1
      this.active = 1
    } else if (this.$route.path === '/faultPage') {
      // this.currentClass = 2
      this.active = 2
    } else if (this.$route.path === '/myPage') {
      // this.currentClass = 3
      this.active = 3
    }
  },
  beforeDestroy () {
    if (localStorage.getItem('AccountsToken') === null) {
      clearInterval(this.timer)// 清除定时器
      this.timer = null
    }
  },
  created () {
    // console.log('created' + 'home')
  },
  activated () {
    // console.log('activated' + 'home')
    // console.log(this.$route.path)
    // 设置tab选中统计
    // this.active = 0
    this.getUserNuReadDiares()
  },
  mounted () {
    // console.log('mounted' + 'home')
    this.getUserNuReadDiares()// 未读故障条数
  },
  methods: {
    tab (index, val) {
      this.currIndex = index
      this.$router.push(val)
    },
    getUserNuReadDiares () {
      // 未读故障条数接口
      this.util.post('/getUserNuReadDiares').then(({ data }) => {
        if (data.code === 200) {
          this.unreadNum = data.data.total
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    }
  },
  computed: {},
  data () {
    return {
      // currentRouter: '/',
      unreadNum: '', // 故障数
      currIndex: 0, // 默认选中tab索引
      active: 0,
      show: false,
      tabbars: [
        {
          path: 'tjPage',
          title: '统计',
          normal: require('../assets/tj@3x.png'),
          active: require('../assets/tj-on@3x.png')
        },
        {
          path: 'xlPage',
          title: '线路',
          normal: require('../assets/xianlu@3x.png'),
          active: require('../assets/xianlu-on@3x.png')
        },
        {
          path: 'faultPage',
          title: '故障',
          normal: require('../assets/gz@3x.png'),
          active: require('../assets/gz-on@3x.png')
        },
        {
          path: 'myPage',
          title: '我的',
          normal: require('../assets/wd@3x.png'),
          active: require('../assets/wd-on@3x.png')
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.fade-enter-active, .fade-leave-active {
  transition: opacity .15s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
